import React, { Component } from 'react';
//Checked
export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			diagnosisError: null
		}
	}
	checkDiagnosisCode = (e) => {
		console.log('here');
		fetch(window.location.origin + window.location.pathname + 'checkimdiagnosiscode', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.navigate('R8')
			} else {
				this.setState({ diagnosisError: await response.text() })
			}
		})
	}
	updateInborn_Metabolic_Diagnosis = (e) => {
		// make value uppercase
		this.props.setData('Inborn_Metabolic_Diagnosis', e.currentTarget.value.toUpperCase());
		//this.props.setData('EnteredDiagnosisCode', true);
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<div>
					<p>Enter the diagnosis related to the Inborn Metabolic Disease. No decimal point entry is allowed. </p>
					<input type="text" value={this.props.data.Inborn_Metabolic_Diagnosis} onChange={this.updateInborn_Metabolic_Diagnosis} />
					<br />
				</div>
				{(this.state.diagnosisError) ? <div className="error">{this.state.diagnosisError}</div> : ''}
				<div className="button" onClick={this.checkDiagnosisCode}>Continue</div>
			</div>
		);
	}
}

//					
